import Carousel from "@/src/components/common/carousel";
import IconCode from "@/src/lib/iconCode";
import Iconify from "@/src/components/iconify";
import TestPrice from "@/src/components/common/test-search/testPrice";
import { useRouter } from "next/router";
import CustomButton from "@/src/lib/ui/Button";
import TatByCity from "@/src/components/common/tat/tatByCity";

const PopularTests = ({ popularTests }) => {
    const router = useRouter();

    const bookNowHandler = (urlSlug) => {
        router.push(`/test/${urlSlug}`);
    };

    return (
        <div className="md:py-8 py-5">
            <div className="max-w-6xl mx-auto">
                <h2 className="md:text-2xl text-xl text-black font-bold md:mb-6 mb-2 md:text-left text-center">
                    Popular Tests
                </h2>
                <Carousel
                    settings={{
                        infinite: true,
                        speed: 700,
                        slidesToShow: 3,
                        slidesToScroll: 2,

                        responsive: [
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 1,
                                    centerMode: true,
                                    centerPadding: "20px",
                                },
                            },
                        ],
                    }}
                >
                    {popularTests?.length > 0 &&
                        popularTests?.map((item, index) => (
                            <div key={index} className="md:py-2 py-1">
                                <div className="md:mx-3 mx-1 flex flex-col rounded-lg bg-white shadow-md">
                                    <div className="flex flex-col">
                                        <div
                                            className="md:min-h-20 min-h-16 flex flex-row items-center justify-between p-4 rounded-2xl"
                                            style={{
                                                background: "red",
                                                backgroundImage:
                                                    "linear-gradient(to right top, #c50000, #d41a15, #e32c27, #f13a38, #ff4848)",
                                                boxShadow:
                                                    "0 8px 10px rgba(255,72,72,0.25)",
                                            }}
                                        >
                                            <h3
                                                className="text-white md:text-base text-sm font-bold !leading-5"
                                                style={{
                                                    maxWidth: "60%",
                                                }}
                                            >
                                                {
                                                    item?.configProductCard
                                                        ?.productName
                                                }
                                            </h3>

                                            <TestPrice
                                                price={
                                                    item?.configProductCard
                                                        ?.cityPrice
                                                }
                                                minPrice={
                                                    item?.configProductCard
                                                        ?.minPrice
                                                }
                                                maxPrice={
                                                    item?.configProductCard
                                                        ?.maxPrice
                                                }
                                                textColor={"text-white"}
                                            />
                                        </div>

                                        <div className="md:p-4 p-2">
                                            <div className="flex flex-row items-center justify-between pb-2 gap-2">
                                                <div className="flex flex-row items-center">
                                                    <Iconify
                                                        icon={IconCode.paramter}
                                                        width="30px"
                                                        color="gray"
                                                        className="mr-1"
                                                    />
                                                    <div>
                                                        <p className="text-sm font-semibold text-gray-600">
                                                            {`${item?.configProductCard?.inclusions?.inclusionCount} ${item?.configProductCard?.inclusions?.inclusionType}`}
                                                        </p>
                                                        <p className="text-xs text-gray-600">
                                                            Included
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex flex-row items-center">
                                                    <Iconify
                                                        icon={
                                                            IconCode.reportTat
                                                        }
                                                        width="30px"
                                                        color="gray"
                                                        className="mr-1"
                                                    />
                                                    <div>
                                                        <p className="text-sm font-semibold text-gray-600 leading-3 pb-1">
                                                            Report TAT
                                                        </p>
                                                        <TatByCity
                                                            tat={item?.configProductCard?.tatByCityId}
                                                            className="text-xs text-gray-600"
                                                        />
                                                        {/* <p className="text-xs text-gray-600">
                                                            {`${
                                                                item
                                                                    ?.configProductCard
                                                                    ?.inclusions
                                                                    ?.defaultTat ||
                                                                "1-5 day(s)"
                                                            }*`}
                                                        </p>  */}
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                className="text-gray-600 md:text-sm line-clamp-2 pb-2"
                                                dangerouslySetInnerHTML={{
                                                    __html: item?.bodyHtml,
                                                }}
                                            ></div>

                                            <div className="flex flex-row items-center gap-2">
                                                <CustomButton
                                                    variant="outlined"
                                                    className="uppercase"
                                                    fullWidth
                                                    onClick={() =>
                                                        bookNowHandler(
                                                            item
                                                                ?.configProductCard
                                                                ?.urlSlug
                                                        )
                                                    }
                                                >
                                                    Know More
                                                </CustomButton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                </Carousel>
            </div>
        </div>
    );
};

export default PopularTests;
